import EditSystemEnvironment from './containers/EditSystemEnvironmentContainer'

export default EditSystemEnvironment
